import { render, staticRenderFns } from "./TodoCenter.vue?vue&type=template&id=74688921&scoped=true"
import script from "./TodoCenter.vue?vue&type=script&lang=js"
export * from "./TodoCenter.vue?vue&type=script&lang=js"
import style0 from "./TodoCenter.vue?vue&type=style&index=0&id=74688921&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74688921",
  null
  
)

export default component.exports